import { replace } from 'connected-react-router'
import { queryKeyDate, queryKeyTime, queryKeyPickupPointId, queryKeyRedemptionLocationId, queryKeyLanguageId } from 'constants/url'
import type { ExperienceOfferPageState } from 'contexts/Experience/ExperienceOfferPage/experienceOfferPageStateReducer'
import { deleteSearchParams, parseSearchString } from 'lib/url/searchUrlUtils'
import { useEffect, useRef } from 'react'

import { useAppDispatch } from 'hooks/reduxHooks'

export const restorableStateQueryParams = [
  queryKeyTime,
  queryKeyPickupPointId,
  queryKeyRedemptionLocationId,
  queryKeyLanguageId,
]

export function getInitialPageState(
  experience: App.ExperienceOffer | undefined,
  search: string,
): ExperienceOfferPageState {
  const queryParams = parseSearchString(search)
  return {
    date: queryParams[queryKeyDate],
    time: queryParams[queryKeyTime],
    pickupPoint: experience?.pickupPoints?.find(p => p.id === queryParams[queryKeyPickupPointId]),
    redemptionLocation: experience?.redemptionLocations?.find(rl => rl.id === queryParams[queryKeyRedemptionLocationId]),
    language: experience?.languages?.find(l => l.id === queryParams[queryKeyLanguageId]),
    ticketCounts: {},
    ticketModesMap: undefined,
  }
}

export function useRemoveStateQueryParams(search: string) {
  const dispatch = useAppDispatch()
  const hasFixedQueryParams = useRef(false)
  useEffect(() => {
    if (hasFixedQueryParams.current) { return }
    hasFixedQueryParams.current = true

    const queryParamKeys = Object.keys(parseSearchString(search))
    if (queryParamKeys.some(key => restorableStateQueryParams.includes(key))) {
      const newSearch = deleteSearchParams(search, ...restorableStateQueryParams)
      dispatch(replace({ search: newSearch }))
    }
  })
}
